import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16.413",
  height: "16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "data-name": "IKONA Stan OK [green]"
    }, [
      _createElementVNode("path", {
        d: "M8.413 0a8 8 0 1 1-8 8 8 8 0 0 1 8-8",
        "data-name": "Path 16973"
      }),
      _createElementVNode("path", {
        stroke: "#46b951",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M1.413 7.752 6.346 13l7.067-9",
        "data-name": "Path 16707"
      })
    ], -1)
  ]))]))
}
export default { render: render }